export class UlReportDevice
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);

            if (json.WhenCreated) this.WhenCreated = new Date(json.WhenCreated);
            if (json.WhenLastKnownCommunication) this.WhenLastKnownCommunication = new Date(json.WhenLastKnownCommunication);
            if (json.WhenLastUpdated) this.WhenLastUpdated = new Date(json.WhenLastUpdated);
        }
    }

    AccountId: number;
    BaseId: number;
    BootVersion: number;
    CommunicationPin: any = null;
    Description: string;
    DeviceGroupId: number;
    DeviceTypeId: number;
    FirmwareVersion: number;
    HardwareVersion: number;
    Id: number;
    ImageAssetId: number = null;
    IsRecognized: false;
    Name: string;
    OrdinalPosition: number;
    ParentId: number;
    SecretId: string;
    UId: string;
    WhenCreated: Date;
    WhenLastKnownCommunication: Date;
    WhenLastUpdated: Date;
}
